import { postVerifyPhone } from '../../../utils/Data/userConnector';
import { returnOnlyNumbers } from '../utilities/accountFormUtilities';
import { isCallSuccessful } from '../../../utils/Data/dataUtilities';
import { useFriendContext } from '../../../utils/ContextProviders/FriendContext';

export function useVerifyUniquePhoneNumber() {
  const { friend, setFriend } = useFriendContext();
  async function verifyUniquePhoneNumber(flags: any) {
    // verify Phone number is unique
    const verifyPhoneResponse = postVerifyPhone(returnOnlyNumbers(friend.phoneNumber));
    if (isCallSuccessful((await verifyPhoneResponse).status)) {
    // if response is true, phone is not unique
    // push user to account-create, show error
      if ((await verifyPhoneResponse).data) {
        if (!flags.skipPhoneNumberValidation) {
          setFriend({ ...friend, isPhoneNumberUnique: false });
          return false;
        }
        return true;
      }
    }
    return false;
  }
  return { verifyUniquePhoneNumber };
}

export default useVerifyUniquePhoneNumber;
